import React, {useState} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Layout } from 'antd'
import { useTranslation } from 'react-i18next';
import { useFirebaseAuth } from "../context/AuthContext";
import { logOut } from "../context/firebaseConfig";
import LanguageSelector from "../components/langSelector/LanguageSelector";

import { PageHeader } from '@ant-design/pro-layout';
import { getPrj } from "../constants/methods";

const MyHeader = (props) => {
    const nav = useNavigate();
    const loc = useLocation();
    const {t} = useTranslation();
    const [user] = useState(useFirebaseAuth());
    const [subtitle] = useState(t(`PAGE_${props.title.toUpperCase()}`))

    const title = process.env[`REACT_APP_${getPrj().toUpperCase()}`] || process.env.REACT_APP_TGD;
    return(

        <PageHeader key='myheader'
            style={{ "backgroundColor": "#001529"}}
            ghost='false'
            title={<h1 style={{fontFamily: "Futura", fontSize: '2em', color:"white"}}>{title}</h1>}
            subTitle={<h3 style={{fontFamily:"Futura", color:'red'}} >{subtitle}</h3>}
            extra={[
                <h3 key='h3_2_header' style={{fontFamily:"Futura", color:'red', paddingTop: '7px'}} >{user.service}</h3>,
                user ? 
                    <Button onClick={() => { logOut(); return nav('/login')}}   key="logout_header"
                        type="primary">{t('BUTTON_LOGOUT')}</Button> 
                 :
                    loc.pathname !== '/login' ?
                        <Button onClick={() => nav('/login')} key="login_header" 
                            type="primary">{t('BUTTON_LOGIN')}</Button> :
                        <div key='no_login_header'></div> ,
                <LanguageSelector key='lgSelector' />,
                <span key='myspn'>{}</span>
            ]}
            
        />
    )
}

export default MyHeader;